import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import Dialog from './Dialog'
import { setFeedback } from '../container/home'

const DialogFeedback = () => {
  const feedback = useSelector(state => state.home.feedback)
  const dispatch = useDispatch()

  const error = !!feedback?.error
  const title = feedback?.title || (error && 'Errore')
  const phrase = feedback?.phrase
  const triggerPath = feedback?.triggerPath

  const handleClose = () => dispatch(setFeedback())

  useEffect(() => {
    if (!feedback) dispatch(setFeedback())
  }, [dispatch, feedback])

  return (
    <Dialog
      open={!!feedback}
      handleClose={handleClose}
      triggerPath={triggerPath}
      title={title}
      textContent={phrase}
      textUndo=''
      textConfirm='Ok'
      error={error}
    />
  )
}

export default DialogFeedback
